import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["amount", "period", "monthlyButton", "annualButton"]
  static classes = ["active", "inactive"]

  connect() {
    this.show("monthly")
  }

  monthly() {
    this.show("monthly")
  }

  annual() {
    this.show("annual")
  }

  show(period) {
    this.amountTargets.forEach((el) => {
      el.textContent = el.dataset[period]
    })
    this.periodTargets.forEach((el) => {
      el.textContent = period === "monthly" ? "/ month" : "/ year"
    })

    const monthlyActive = period === "monthly"
    this.monthlyButtonTarget.classList.toggle("bg-navy-900", monthlyActive)
    this.monthlyButtonTarget.classList.toggle("text-paper-main", monthlyActive)
    this.monthlyButtonTarget.classList.toggle("border-navy-900", monthlyActive)
    this.monthlyButtonTarget.classList.toggle("bg-transparent", !monthlyActive)
    this.monthlyButtonTarget.classList.toggle("text-navy-800", !monthlyActive)
    this.monthlyButtonTarget.classList.toggle("border-navy-400", !monthlyActive)

    this.annualButtonTarget.classList.toggle("bg-navy-900", !monthlyActive)
    this.annualButtonTarget.classList.toggle("text-paper-main", !monthlyActive)
    this.annualButtonTarget.classList.toggle("border-navy-900", !monthlyActive)
    this.annualButtonTarget.classList.toggle("bg-transparent", monthlyActive)
    this.annualButtonTarget.classList.toggle("text-navy-800", monthlyActive)
    this.annualButtonTarget.classList.toggle("border-navy-400", monthlyActive)
  }
}
